import { render } from '../../core/shell.js';
import { S, UI, save } from '../../core/store.js';
import { toast } from '../../core/ui.js';

export const actions={
dept(el){UI.dept=el.dataset.d;render()},
stdone(el){const t=S.stasks.find(x=>x.id===el.dataset.id);if(t)t.done=1;save();render();toast('Marked done')}
};
